import { Component, Input } from '@angular/core';

@Component({
    selector: 'pw-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
//TODO try to integrate is, searchText @Input() did not work!!!
export class FilterComponent {

    @Input() searchText = '';

    @Input() placeHolder = '';

    get searchTextValue() {
        return this.searchText;
    }

    constructor() {

    }

}
